import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const AuthModalContext = createContext(null);

export const AUTH_MODAL_VIEWS = {
  LOGIN: 'login',
  SIGNUP: 'signup',
};

export const AuthModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState(AUTH_MODAL_VIEWS.LOGIN);

  const openLogin = useCallback(() => {
    setView(AUTH_MODAL_VIEWS.LOGIN);
    setIsOpen(true);
  }, []);

  const openSignup = useCallback(() => {
    setView(AUTH_MODAL_VIEWS.SIGNUP);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(
    () => ({ isOpen, view, openLogin, openSignup, close, setView }),
    [isOpen, view, openLogin, openSignup, close],
  );

  return <AuthModalContext.Provider value={value}>{children}</AuthModalContext.Provider>;
};

export const useAuthModal = () => {
  const ctx = useContext(AuthModalContext);
  if (!ctx) {
    throw new Error('useAuthModal must be used within an AuthModalProvider');
  }
  return ctx;
};
